
import React, { FunctionComponent } from 'react';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonNew from '../Button/Button';
import CloseIcon from '@mui/icons-material/Close';
import { t } from 'i18next';
import { Breakpoint } from '@mui/material';
import { themes } from 'theme/themes';
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';
interface FormDialogProps {
  open: boolean;
  onClose: (event?: any, reason?: any) => void;
  title: string;
  content: React.ReactNode;
  saveFunction?: () => void;
  icon?: React.ReactNode;
  submitButtonText?: string;
  createPopup?: boolean;
  fullWidth?: boolean;
  hideActions?: boolean;
  maxWidth?: false | Breakpoint | undefined;
  hideClose?: boolean;
  cancelBtnText?: string;
  fullScreen?: boolean;
  hideTitle?: boolean;
}

const FormDialog: FunctionComponent<FormDialogProps> = ({
  open,
  onClose,
  title,
  content,
  saveFunction,
  submitButtonText,
  icon,
  createPopup,
  fullWidth,
  hideActions,
  maxWidth,
  hideClose,
  cancelBtnText,
  fullScreen,
  hideTitle
}) => {
  const branding = useSelector(brandingInfo);
  const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
  return (
    <Dialog open={open} fullScreen={fullScreen} onClose={onClose} disableEscapeKeyDown fullWidth={fullWidth} maxWidth={maxWidth || "lg"} >
        {/* <form 
        onSubmit={handleSubmit}
        > */}
      {hideTitle ? null : <DialogTitle style={{background: themeColors?.primary, display:"flex", justifyContent:"space-between",  alignItems:"center"}} >
        {/* {title} */}
        <div className='flex items-center'>
            <span className='mr-[5px] invert'>{icon}</span>
            <h1 className="font-Saira font-bold text-white text-lg">{t(title)}</h1>
          </div>
          {hideClose ? null : <CloseIcon className='cursor-pointer text-white' onClick={onClose}/>}
      </DialogTitle>}
      <DialogContent className='py-3'>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      {hideActions ? null : <DialogActions className={createPopup ? 'justify-end mb-[10px]' : 'justify-end'}>
        {createPopup ? null :
          <div className='h-[39px] w-[102px] rounded-md flex items-center justify-center'>
            <ButtonNew type='back' onClick={onClose} text={cancelBtnText || t('Cancel')}></ButtonNew>
          </div>
        }
        <ButtonNew type="create" onClick={saveFunction} text={submitButtonText} >
        </ButtonNew>
      </DialogActions>}
      {/* </form> */}
    </Dialog>
  );
};

export default FormDialog;
